module.exports = __webpack_public_path__ + "static/img/img_guide1.76ae0d99.png";